/**
 * @file components/chat/StatusTicks.tsx
 * Les "cochettes" WhatsApp.
 *   - sent      → ✓   grise
 *   - delivered → ✓✓  grise
 *   - read      → ✓✓  bleue
 */
import React from 'react';
import { Check, CheckCheck } from 'lucide-react';
import type { TickStatus } from './types.ts';

export default function StatusTicks({
  status,
}: {
  status?: TickStatus | undefined;
}): React.ReactElement | null {
  if (!status) return null;

  if (status === 'sent') {
    return <Check size={14} className="text-primary-foreground/60" aria-label="Envoyé" />;
  }

  const color = status === 'read' ? 'text-sky-300' : 'text-primary-foreground/60';
  return (
    <CheckCheck
      size={14}
      className={color}
      aria-label={status === 'read' ? 'Lu — analyse terminée' : 'Distribué — traitement démarré'}
    />
  );
}
